import { __ } from '@wordpress/i18n';

import {
	File,
	Square,
	Tag,
	Image,
	Slice,
	Globe,
	Thunder,
	Gear,
	Plus,
} from 'akar-icons';

const ShortcutsGrid = () => {
	// Base url
	const baseURL = boilpressApi.baseURL;

	const shortcuts = [
		{
			icon: <File size={ 16 } />,
			title: __( 'Posts', 'boilpress' ),
			url: `${ baseURL }/wp-admin/edit.php`,
		},
		{
			icon: <Square size={ 16 } />,
			title: __( 'Blocks', 'boilpress' ),
			url: `${ baseURL }/wp-admin/edit.php?post_type=wp_block`,
		},
		{
			icon: <Tag size={ 16 } />,
			title: __( 'Categories', 'boilpress' ),
			url: `${ baseURL }/wp-admin/edit-tags.php?taxonomy=category`,
		},
		{
			icon: <Image size={ 16 } />,
			title: __( 'Media', 'boilpress' ),
			url: `${ baseURL }/wp-admin/upload.php`,
		},
		{
			icon: <Slice size={ 16 } />,
			title: __( 'Patterns', 'boilpress' ),
			url: `${ baseURL }/wp-admin/site-editor.php?postType=wp_block`,
		},
		{
			icon: <Globe size={ 16 } />,
			title: __( 'Pages', 'boilpress' ),
			url: `${ baseURL }/wp-admin/edit.php?post_type=page`,
		},
		{
			icon: <Thunder size={ 16 } />,
			title: __( 'Plugins', 'boilpress' ),
			url: `${ baseURL }/wp-admin/plugins.php`,
		},
		{
			icon: <Gear size={ 16 } />,
			title: __( 'Settings', 'boilpress' ),
			url: `${ baseURL }/wp-admin/options-general.php`,
		},
	];

	return (
		<div
			style={ {
				display: 'grid',
				gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
				gap: '0.5rem',
			} }
		>
			{ shortcuts.map( ( shortcut ) => (
				<>
					<div>
						<button
							style={ {
								aspectRatio: '16 / 9',
								backgroundColor: '#3582c4',
								border: '1px solid transparent',
								fontWeight: 'bold',
								justifyItems: 'center',
								alignItems: 'center',
								boxSizing: 'border-box',
								borderTopRightRadius: 0,
								borderBottomRightRadius: 0,
								color: 'white',
								cursor: 'pointer',
								transition: 'all 0.3s ease-in-out',
								width: '100%',
								height: '100%',
								borderRadius: '2px',
							} }
							key={ shortcut.title }
							onClick={ () =>
								( window.location.href = shortcut.url )
							}
						>
							<div className="shortcut-icon">
								{ shortcut.icon }
							</div>
							<div className="shortcut-title">
								{ shortcut.title }
							</div>
						</button>
					</div>
				</>
			) ) }
		</div>
	);
};

export default ShortcutsGrid;
